export const notificationsSelector = state => state.notifications;
